import {
	CheckinOrderFragment,
	CheckoutOrderFragment,
	GdsServiceVipSubType,
	GdsService_OrderAdditionalServiceGdsServiceVip_Fragment,
	OrderAdditionalServiceGdsServiceServiceType
} from '@websky/graphql';
import { State } from './types';
import { isCheckoutOrderGuard } from '../../../../typeguards';

export const initialStateFactory = (order: CheckinOrderFragment | CheckoutOrderFragment): State => {
	const state: State = {
		activeService: null,
		services: {}
	};

	const transferServices: GdsService_OrderAdditionalServiceGdsServiceVip_Fragment[] = [];

	for (const service of order?.additionalServices?.gdsServices?.services) {
		if (
			service.type === OrderAdditionalServiceGdsServiceServiceType.Vip &&
			(service as GdsService_OrderAdditionalServiceGdsServiceVip_Fragment).subType ===
				GdsServiceVipSubType.GroundTransportation
		) {
			transferServices.push(service as GdsService_OrderAdditionalServiceGdsServiceVip_Fragment);
		}
	}

	if (isCheckoutOrderGuard(order)) {
		for (const transferService of transferServices) {
			for (const serviceSegmentGroup of transferService.allowedSegments) {
				for (const segmentId of serviceSegmentGroup) {
					for (const allowedPassengerGroup of transferService.allowedPassengers) {
						for (const allowedPassenger of allowedPassengerGroup) {
							const traveller = order.travellers.find(traveller => traveller.id === allowedPassenger);
							const travellerTransferService = traveller?.services?.gdsServices?.services?.find(
								travellerService => travellerService.serviceId === transferService.id
							);

							if (!state.services[allowedPassenger]) {
								state.services[allowedPassenger] = {};
							}

							if (!state.services[allowedPassenger][segmentId]) {
								state.services[allowedPassenger][segmentId] = [
									{
										service: transferService,
										selected: travellerTransferService?.count > 0,
										confirmed: travellerTransferService?.confirmedCount > 0
									}
								];
							} else {
								state.services[allowedPassenger][segmentId].push({
									service: transferService,
									selected: travellerTransferService?.count > 0,
									confirmed: travellerTransferService?.confirmedCount > 0
								});
							}
						}
					}
				}
			}
		}
	} else {
	}

	return state;
};
